import React, { useContext, useMemo } from 'react'
import _ from 'lodash'
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import ItemMenuSquares, { _imsTypes } from './ItemMenuSquares';
import Wrapper, { wrapperTypes } from './Wrapper';
import { motion } from 'framer-motion'
import { Icon } from 'semantic-ui-react';
import { appUserLevels } from 'global/enums/globalEnums';
import { BaseSettingsContext } from 'global/cnr/contexts/BaseSettingsContext';
import FileManagement from 'global/components/viewers/FileManagement';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import { useBreadcrumbs } from 'global/cnr/contexts/useHelpers/useBreadcrumbs';
import { SquaresContext } from './SquaresWrapper';
import { menuItemItems, menuItemItems_views } from 'global/viewSettings/components/menus/menuItemHelpers';
import { PopupSelect } from 'global/components/popups/PopupSelect';
import { listHelpers } from 'global/lists/lists';
import { IconSelect } from 'global/components/popups/IconSelect';
import { convertHelpers } from 'global/common/convert';

export const _squareTypes = {
  files: 'files',
  grouped: 'grouped',
  pageItem: 'pageItem',
  pageItems: 'pageItems',
  pages_global: 'pages_global',
  pages_page: 'pages_page',
  props: 'props',
  propSection: 'propSection',
  pageProps: 'pageProps',
  pageSections: 'pageSections',
  main: 'main',
  childItem: 'childItem',
}

const _sqrIconTypes = {
  files: 'list',
  grouped: 'list',
  pageItem: 'list',
  pageItems: 'list',
  pages_global: 'list',
  pages_page: 'list',
  props: 'list',
  propSection: 'list',
  pageProps: 'list',
  pageSections: 'list',
  main: 'list',
  childItem: 'list',
}

const _pageAreaTypes_global = ['all', 'global'] // all/global/page
const _pageAreaTypes_page = ['all', 'page'] // all/global/page

const itemTransition = { duration: 0.25, ease: 'easeOut' };

/**
 * 
 * @param {*} param0 
 * @returns 
 */
export const SquareSquares = ({
  _pageView,
  allGroups,
  currentData,
  currentGroup,
  direction,
  handle_goNext,
  handle_viewUpdate,
  isGlobal,
  isMain,
  squareType,
}) => {

  const appUserAccess = useAppUserAccess()
  const { accessLevel } = appUserAccess ?? {}

  //parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { currentSettings_state, paps_state } = states ?? {}
  const { aps_global, aps_viewItems, aps_views } = _.get(currentSettings_state, 'gvviSettings', {});
  const { projectModules, projectOptions } = aps_global ?? {}

  const viKeys = _.keys(aps_viewItems)

  // baseSettingsContext
  const baseSettingsContext = useContext(BaseSettingsContext)
  const { baseSettings_state } = baseSettingsContext ?? {}

  // squaresContext
  const squaresContext = useContext(SquaresContext)
  const { squares_state, squares_handlers } = squaresContext ?? {}
  const { apsViewItems, apsViews } = squares_state

  const handleSquareType = (e, item, itemKey, st) => {
    e.stopPropagation()
    const _item = _.cloneDeep(item)
    _item.key = 'propSections'
    handle_goNext(_item)
  }

  const fnAltData = () => {
    const currentGroup = squares_state?.allGroups?.[squares_state?.allGroups.length - 1] || null
    if (currentGroup.isAlt) {
      squares_handlers.handleGo_back()
    } else {
      const ng = {
        key: 'propSections',
        caption: 'Prop Sections',
        isAlt: true
      }
      // _replacementGroup.key = 'propSections'
      // _replacementGroup.caption = 'Prop Sections'
      // _replacementGroup.isAlt = true 
      squares_handlers.handleGo_next(ng)
    }

  }

  const backLinks = useMemo(() => {
    const bl = _.map(
      allGroups.slice(0, -1),
      (group, index) => (
        {
          key: group.key || 0,
          caption: group.caption || _.startCase(group?.key) || 'App Settings'
        }
      )
    );
    return bl
  }, [allGroups])


  const bcrb = useBreadcrumbs({ items: backLinks, onClick: squares_handlers.handleGo_backTo })

  const motion_wrapper = (content, formKey) => <motion.div
    className={'mwsw ss'}
    key={formKey || 'key'}
    layout
    initial={{ opacity: 0, y: 0, x: getX(direction) }}
    animate={{ opacity: 1, y: 0, x: 0 }}
    exit={{ opacity: 0, y: 0, x: getX(direction) }}
    transition={itemTransition}>
    {content}
  </motion.div>

  const header_top = () => {
    const { caption, key } = currentGroup
    const _caption = caption || _.startCase(key)

    return <div className='swr-header'>
      {bcrb}
      <div className='swr-header-cap'><Icon color={'blue'} name='arrow left' onClick={(e) => squares_handlers.handleGo_back()}></Icon>{_caption}</div>
    </div>
  }

  const wrapper = (content, key) => <Wrapper
    header={!isMain && header_top()}
    content={motion_wrapper(content, key)}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  /**
   * 
   * @param {*} item 
   * @param {*} itemKey 
   * @returns additional element for the square item
   */
  const fnAltContent = (item, itemKey) => {
    let pus;
    let icns;

    const cb = (selectedItem) => {
      switch (squareType) {
        case _squareTypes.pageProps:
          if (isGlobal) {

          } else {
            const cps = `${squares_state?.pageView}.${squares_state.keyPath}.${itemKey}`
            const cfps = `viewItems.${itemKey}.props.${selectedItem}`
            item[selectedItem] = !item[selectedItem]
            squares_handlers.handleSet_value(item, cps, cfps, itemKey)
          }
          break;

        case _squareTypes.pages_page:
          let _view = squares_state?.view
          switch (_view) {
            case 'landing':
              _view = 'events'
              break;
          }
          const cp = `${_view}.viewItems.${itemKey}`
          const cfp = `viewItems.${itemKey}.${selectedItem}`
          item[selectedItem] = !item[selectedItem]
          squares_handlers.handleSet_value(item, cp, cfp, itemKey)
          break;
        case _squareTypes.pageSections:
          if (isGlobal) {
            const kp = squares_state.keyPath.replace('views', 'viewItems')
            const cps = `${kp}.${itemKey}`
            const cfps = `viewItems.${itemKey}.propSections.${selectedItem}`
            item[selectedItem] = !item[selectedItem]
            squares_handlers.handleSet_value(item, cps, cfps, itemKey)
          } else {
            const cps = `${squares_state?.view}.${squares_state.keyPath}.${itemKey}`
            const cfps = `viewItems.${itemKey}.propSections.${selectedItem}`
            item[selectedItem] = !item[selectedItem]
            squares_handlers.handleSet_value(item, cps, cfps, itemKey)
          }
          break;
        case _squareTypes.pageProps:
      }
    }

    switch (squareType) {
      case _squareTypes.pageItems:
      case _squareTypes.pageItem:
        switch (itemKey) {
          case 'props':
            return <div><Icon name='object ungroup outline' onClick={(e) => handleSquareType(e, item, itemKey, _squareTypes.pageSections)}></Icon></div>
        }
        break;
      // case _squareTypes.pages_global:
      //   return <div>GL</div>
      case _squareTypes.pages_page:
        pus = <PopupSelect items={menuItemItems_views} dataItem={item} handleMenuAction={cb} icon={'ellipsis vertical'} />
        break;
      case _squareTypes.pageProps:
        icns = <IconSelect items={menuItemItems} dataItem={item} />
        pus = <PopupSelect items={menuItemItems} dataItem={item} handleMenuAction={cb} icon={'ellipsis vertical'} />
        break;
      case _squareTypes.pageSections:
        pus = <PopupSelect items={menuItemItems_views} dataItem={item} handleMenuAction={cb} icon={'ellipsis vertical'} />
        break;
      default:
      // nothing
    }

    if (pus) {
      return <div style={{ display: 'flex', flexDirection: 'row', columnGap: '.25em' }}>{icns}{pus}</div>
    }
  }

  const itemSquares = (menuItems, caption, icon, iconColor, imsType, altContent, altData) => <ItemMenuSquares
    caption={caption}
    currentData={currentData}
    fn_altContent={altContent}
    fnAltData={altData}
    group={currentGroup}
    handle_viewUpdate={handle_viewUpdate}
    icon={icon}
    iconColor={iconColor}
    iconItem={_sqrIconTypes[squareType]}
    imsType={imsType || _imsTypes.inline}
    menuItems={menuItems}
    onClick={handle_goNext}
    squareType={squareType}
    isGlobal={isGlobal}
  />

  /**
   * 
   * @returns squares for the main listings
   */
  const squares_main = () => {
    const x = []
    _.forEach(currentGroup, (mag, authLevel) => {
      if (accessLevel >= authLevel) {
        const n = Number.isFinite(Number(authLevel)) ? Number(authLevel) : null
        const zzz = _.find(appUserLevels, { value: n })
        const { color: settingsColor, icon: settingsIcon, caption } = zzz || {}
        const filtered = getFiltered(mag.groupedItems, projectOptions)
        x.push(itemSquares(gisOrdered(filtered), caption, settingsIcon || 'settings', mag.iconColor || settingsColor, _imsTypes.inline))
      }
    })
    return wrapper(x)
  }

  /**
   * 
   * @returns squares for the childItems
   */
  const squares_childItem = () => {
    const { childItems, childMenuItem } = currentGroup
    const x = []
    const _groupItems = listHelpers.createItemList(childItems)
    const gl = listHelpers.createGroupList(_groupItems, childMenuItem)
    x.push(itemSquares(gl, 'Settings', 'settings', 'grey'))
    return wrapper(x)
  }

  /**
 * 
 * @returns squares for the grouped items
 */
  const squares_grouped = () => {
    const x = []
    const { groupItems } = currentGroup
    let _groupItems = groupItems
    let _gis = _groupItems


    const _groupItems_div = groupByDividedText(_groupItems, 'dividedText')
    let _combinedItems;

    const hasMultiItem = _.some(_groupItems_div, obj =>
      _.get(obj, 'items.length', 0) > 1
    );

    if (!hasMultiItem) {
      _combinedItems = _.sortBy(
        _.flatMap(_groupItems_div, obj => obj.items || []),
        item => item?.caption
      )
    }

    switch (currentGroup.key) {
      case 'appModules':
        _gis = _.filter(_gis, item => allowProjectModule(item.key, projectModules) === true)
        break;
    }

    if (!hasMultiItem && !_.isEmpty(_combinedItems)) {
      x.push(itemSquares(_combinedItems, currentGroup.key ? _.startCase(currentGroup.key) : null, currentGroup?.icon || 'settings', currentGroup.iconColor || 'blue'))
    } else {
      if (!_.isEmpty(_groupItems_div)) {
        _.forEach(_groupItems_div, (grpItem) => {
          x.push(itemSquares(grpItem.items, hasMultiItem && grpItem.key ? _.startCase(grpItem.key) : null, 'settings', currentGroup.iconColor || 'blue'))
        })
      } else if (_gis) {
        x.push(itemSquares(_gis, currentGroup.key ? _.startCase(currentGroup.key) : 'Settings', 'settings', currentGroup.iconColor || 'blue'))
      }
    }

    return wrapper(x)
  }

  /**
 * 
 * @returns squares for the global pages
 */
  const squares_pages_global = (allowSorting) => {
    const x = []
    const _gis = sortObjectByChildPath(apsViewItems, 'key')
    x.push(itemSquares(_gis, currentGroup?.caption, 'settings', currentGroup.iconColor || 'blue', _imsTypes.inline, fnAltContent))
    return wrapper(x)
  }

  /**
  * 
  * @returns squares for the page pages
  */
  const squares_pages_page = () => {
    const x = []
    const _pv = _pageView === 'landing' ? 'events' : _pageView
    const viewItems = apsViews?.[_pv]?.viewItems
    const _gis = sortObjectByChildPath(viewItems, 'position')
    x.push(itemSquares(_gis, currentGroup?.caption, 'settings', currentGroup.iconColor || 'blue', _imsTypes.inline, fnAltContent))
    return wrapper(x)
  }

  /**
   * 
   * @returns squares for the page item
   */
  const squares_pageItem = () => {
    const x = []
    const filteredAndGrouped = getSplitItems(baseSettings_state, _pageAreaTypes_global, 'pageItem', 'global')
    const _currentPageGroup = {}
    _.forEach(filteredAndGrouped, (fg, fgk) => {
      _currentPageGroup[fgk] = {
        groupedItems: fg,
        iconColor: 'pink',
      }
    })
    _.forEach(_currentPageGroup, (mag, authLevel) => {
      const n = Number.isFinite(Number(authLevel)) ? Number(authLevel) : null
      const zzz = _.find(appUserLevels, { value: n })
      const { color: settingsColor, icon: settingsIcon, caption } = zzz || {}
      x.push(itemSquares(mag.groupedItems, ` ${caption}`, settingsIcon, settingsColor, null, fnAltContent))
    })
    return wrapper(x)
  }

  /**
   * 
   * @returns squares for the page items
   */
  const squares_pageItems = () => {
    const x = []
    const filteredAndGrouped = getSplitItems(baseSettings_state, _pageAreaTypes_page, 'pageItem', 'page')
    const _currentPageGroup = {}
    _.forEach(filteredAndGrouped, (fg, fgk) => {
      _currentPageGroup[fgk] = {
        groupedItems: fg,
        iconColor: 'pink',
      }
    })
    _.forEach(_currentPageGroup, (mag, authLevel) => {
      const n = Number.isFinite(Number(authLevel)) ? Number(authLevel) : null
      const zzz = _.find(appUserLevels, { value: n })
      const { color: settingsColor, icon: settingsIcon, caption } = zzz || {}
      x.push(itemSquares(mag.groupedItems, ` ${caption}`, settingsIcon, settingsColor, null, fnAltContent))
    })
    return wrapper(x)
  }

  /**
   * 
   * @returns squares for the files
   */
  const squares_files = () => {
    const x = []
    x.push(<FileManagement split={true} fileOptionType={'global'} storageType={'icon'} />)
    return wrapper(x)
  }

  /**
   * 
   * @returns squares for the props
   */
  const squares_props = () => {
    const x = []
    const filteredAndGrouped = isGlobal ? getSplitItems(baseSettings_state, _pageAreaTypes_global, 'prop', 'global') : getSplitItems(baseSettings_state, _pageAreaTypes_page, 'prop', 'page')
    const _currentPageGroup = {}
    _.forEach(filteredAndGrouped, (fg, fgk) => {
      _currentPageGroup[fgk] = {
        groupedItems: fg,
        iconColor: 'pink',
      }
    })
    _.forEach(_currentPageGroup, (mag, authLevel) => {
      const n = Number.isFinite(Number(authLevel)) ? Number(authLevel) : null
      const zzz = _.find(appUserLevels, { value: n })
      const { color: settingsColor, icon: settingsIcon, caption } = zzz || {}
      x.push(itemSquares(mag.groupedItems, `Page Settings`, settingsIcon, settingsColor))
    })
    return wrapper(x)
  }

  const squares_propSection = () => {
    const x = []
    const filteredAndGrouped = getSplitItems(baseSettings_state, _pageAreaTypes_global, 'propSection', 'global')
    const _currentPageGroup = {}
    _.forEach(filteredAndGrouped, (fg, fgk) => {
      _currentPageGroup[fgk] = {
        groupedItems: fg,
        iconColor: 'pink',
      }
    })
    _.forEach(_currentPageGroup, (mag, authLevel) => {
      const n = Number.isFinite(Number(authLevel)) ? Number(authLevel) : null
      const zzz = _.find(appUserLevels, { value: n })
      const { color: settingsColor, icon: settingsIcon, caption } = zzz || {}
      x.push(itemSquares(mag.groupedItems, `Page Settings`, settingsIcon, settingsColor, null, null, null, 'list'))
    })
    return wrapper(x)
  }

  /**
 * 
 * @returns squares for the propSections
 */
  const squares_pageSections = () => {
    const index = isGlobal ? 3 : 2
    const psGroup = allGroups?.[index]
    let _propSections = {}

    if (isGlobal) {
      const grp = _.find(allGroups, { parentGroupKey: 'views' })
      const { key: key_views } = grp ?? {}
      _propSections = _.get(apsViewItems, `${key_views}.propSections`, {});
    } else {
      _propSections = apsViews?.[squares_state.view]?.viewItems[psGroup?.key]?.propSections
    }

    const x = [];
    x.push(itemSquares(_propSections, _.startCase('propSections'), 'list', 'blue', null, fnAltContent, fnAltData));
    return wrapper(x)
  }

  const matchKeysInPath = (viKeys, keyPath) => {
    const parts = keyPath.split('.');
    const xxx = _.intersection(viKeys, parts);
    return xxx?.[0] || ''
  };

  /**
   * 
   * @returns squares for the pageProps
   */
  const squares_pageProps = () => {

    const index = isGlobal ? 3 : 2
    const psGroup = allGroups?.[index]

    let _props;
    let _propSections;

    if (isGlobal) {
      const currVi = matchKeysInPath(viKeys, squares_state.keyPath)
      _props = apsViewItems?.[currVi]?.props
      _propSections = apsViewItems?.[currVi]?.propSections
    } else {
      _props = apsViews?.[squares_state.pageView]?.viewItems[psGroup?.key]?.props
      _propSections = apsViews?.[squares_state.view]?.viewItems[psGroup?.key]?.propSections
    }

    convertHelpers.createItemKeys(_propSections, 'key')

    // 1. group props by propSection, keeping prop keys
    const grouped = _.reduce(_props, (acc, prop, propKey) => {
      const sectionKey = prop.propSection;
      if (!sectionKey) return acc;
      if (!acc[sectionKey]) acc[sectionKey] = {};
      acc[sectionKey][propKey] = prop;
      return acc;
    }, {});

    const props_sectioned = Object.fromEntries(
      Object.entries(grouped).sort(
        ([a], [b]) =>
          (_propSections?.[a]?.position ?? Infinity) -
          (_propSections?.[b]?.position ?? Infinity)
      )
    );

    const sectionProps = getProps_sectioned(props_sectioned, _propSections, _props)

    const x = [];
    x.push(itemSquares(sectionProps, _.startCase('props'), 'list', 'blue', null, fnAltContent, fnAltData, 'list'));

    return wrapper(x)

  }

  switch (squareType) {
    case _squareTypes.childItem:
      return squares_childItem()
    case _squareTypes.files:
      return squares_files()
    case _squareTypes.grouped:
      return squares_grouped()
    case _squareTypes.main:
      return squares_main()
    case _squareTypes.pageItem:
      return squares_pageItem()
    case _squareTypes.pageItems:
      return squares_pageItems()
    case _squareTypes.pages_global:
      return squares_pages_global()
    case _squareTypes.pages_page:
      return squares_pages_page()
    case _squareTypes.pageProps:
      return squares_pageProps()
    case _squareTypes.pageSections:
      return squares_pageSections()
    case _squareTypes.props:
      return squares_props()
    case _squareTypes.propSection:
      return squares_propSection()
    default:
    // nothing
  }
}

const groupByDividedText = (groupItems = [], divider, divider2) => {
  return _.transform(
    _.sortBy(groupItems, '_position'),
    (acc, item) => {
      let hasDivider = item?.[divider];

      if (hasDivider) {
        const key = divider2
          ? item?.[divider]?.[item[divider2]]
          : item?.[divider];

        acc.push({
          key,
          items: []
        });
      }

      // 👇 If no group yet, create a default one
      if (!acc.length) {
        acc.push({
          key: null,
          items: []
        });
      }

      acc[acc.length - 1].items.push(item);
    },
    []
  );
};

const allowProjectModule = (key, projectModules) => {

  const _key = key ? key.replace(/^app/, 'allow') : 'none';
  let allow = projectModules?.[_key]
  switch (key) {
    case 'notificationsManager':
      return projectModules?.allowNotifications
  }

  return allow

}

const sortObjectByChildPath = (obj, childPath, order = 'asc') => {
  if (!_.isPlainObject(obj)) return obj;

  return _.fromPairs(
    _.orderBy(
      _.toPairs(obj),
      ([, item]) => _.get(item, childPath),
      [order]
    )
  );
};

function getSplitItems(baseSettings_state, pageAreaTypes, splitType, pageAreaType) {

  const bss = _.cloneDeep(baseSettings_state)
  const items = _.get(bss, `saSplits.${splitType}.${pageAreaType}`, {});

  // Step 1: filter the items 
  const filtered = _.pickBy(items, (item, key) => {
    if (item.restrict || item.hideFromMenu) return false;

    // fill missing caption with key
    if (!item.caption) item.caption = key;

    const pageAreaOk =
      !pageAreaTypes ||
      !item.componentAreas?.pageAreaTypes ||
      _.intersection(item.componentAreas.pageAreaTypes, pageAreaTypes).length > 0;

    return pageAreaOk;
  });

  // Step 2: group by settingsAuthLevel while preserving keys
  const grouped = {};
  _.forEach(filtered, (pageItem, key) => {
    const level = pageItem.settingsAuthLevel;
    if (!grouped[level]) grouped[level] = {};
    grouped[level][key] = pageItem;
  });

  // Step 3: sort each group by caption
  const sortedGrouped = _.mapValues(grouped, group =>
    Object.fromEntries(
      Object.entries(group).sort(([, itemA], [, itemB]) =>
        itemA.caption.localeCompare(itemB.caption)
      )
    )
  );

  return sortedGrouped;
}

const getFiltered = (items, projectOptions) => {
  const filtered = _.pickBy(items, (item, key) => {
    if (item.restrict || item.hideFromMenu) return false;
    switch (key) {
      case 'pageOptions':
        if (_.isEmpty(projectOptions)) return false;
      default:
      // nothing
    }
    return item;
  });
  return filtered
}

const getX = (direction) => {
  switch (direction) {
    case 'left':
      return -20; // enters from left
    case 'right':
      return 20;  // enters from right
    default:
      return 0;
  }
};

const gisOrdered = (items) => {
  return _.orderBy(
    _.filter(items, item =>
      !_.isEmpty(item.groupItems)
    ),
    ['caption']
  )
}

const getProps_sectioned = (props_sectioned, _propSections, _props) => {

  const someArray = [];
  let _position = 0

  const _prop_sections = _.sortBy(_propSections, 'position')

  _.forEach(_prop_sections, (ps, psk) => {
    const _pos = ps.position || _position
    ps.position = _pos
    _position++
  })

  const prps = _.groupBy(_props, 'propSection')

  let _propPosition = 0

  _.forEach(_prop_sections, (ps) => {
    someArray.push({
      key: `${ps.key}-placeholder`,
      _isFirstItem: true,
      propSection: ps.key,
      position: _propPosition
    });
    _propPosition++
    const secProps = prps[ps.key]
    _.forEach(secProps, (prop) => {
      someArray.push({
        ...prop,
        position: _propPosition
      });
      _propPosition++
    });
  })


  console.group('getProps_sectioned')
  console.log('_props', _props)
  console.log('_prop_sections', _prop_sections)
  console.log('prps', prps)
  console.log('someArray', _.sortBy(someArray, 'position'))
  console.groupEnd()

  return someArray;
};
